import {attr, controller} from '@github/catalyst'
import type {GetRepoElement} from '@github-ui/get-repo-element'
import {observe} from '@github-ui/selector-observer'

@controller('repo-codespaces-count')
class RepoCodespacesCountElement extends HTMLElement {
  static attrPrefix = ''
  @attr codespacesCount = 0

  async connectedCallback() {
    // `get-repo` is lazily defined (see the element-registry auto-injection), so it
    // may not be upgraded yet. Wait for its definition, then observe with the real
    // constructor so the `instanceof` gate and the element's methods are available.
    const GetRepoCtor = (await customElements.whenDefined('get-repo')) as typeof GetRepoElement
    observe('get-repo', {
      constructor: GetRepoCtor,
      add: el => {
        this.handleGetRepoElement(el)
      },
    })
  }

  handleGetRepoElement(getRepoElement: GetRepoElement) {
    if (!getRepoElement.openOrCreateInCodespace) {
      return
    }
    if (this.codespacesCount === 0) {
      getRepoElement.showOpenOrCreateInCodespace()
    } else {
      getRepoElement.removeOpenOrCreateInCodespace()
    }
  }
}
